import api from '../utils/api';
import qs from '../utils/qs';

export const getTemplates = async (data) => {
    try {
        const response = await api.post(`/templates/search`, data);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getTemplatesById = async (id) => {
    try {
        const response = await api.get(`/templates/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const addTemplates = async (data) => {
    try {
        const response = await api.post(`/templates`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const editTemplates = async (params, data) => {
    try {
        const response = await api.put(`/templates/${params}`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const deleteTemplate = async (params) => {
    try {
        const response = await api.put(`/templates/status/${params}`, { status: 2 });
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const templateStatusChange = async (params,data) => {
    try {
        const response = await api.put(`/templates/status/${params}`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}